@if (visible()) {
  <div class="overlay">
    <div class="spinner"></div>
  </div>
}
